import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../../axiosApi';

export const serverMetricsGet = createAsyncThunk('serverHealth/metrics', async () => {
  return await apiInstance.get('/system-monitor/metrics');
});

export const serverServicesGet = createAsyncThunk('serverHealth/services', async () => {
  return await apiInstance.get('/system-monitor/services');
});

export const pm2Action = createAsyncThunk('serverHealth/pm2Action', async (payload) => {
  return await apiInstance.post('/system-monitor/pm2/action', payload);
});

export const pm2RestartAll = createAsyncThunk('serverHealth/pm2RestartAll', async (payload) => {
  return await apiInstance.post('/system-monitor/pm2/restart-all', payload);
});

export const serviceAction = createAsyncThunk('serverHealth/serviceAction', async (payload) => {
  return await apiInstance.post('/system-monitor/service/action', payload);
});

export const systemAction = createAsyncThunk('serverHealth/systemAction', async (payload) => {
  return await apiInstance.post('/system-monitor/system/action', payload);
});

const initialState = {};

const serverHealthSlice = createSlice({
  name: 'serverHealth',
  initialState,
  reducers: {
    clearServerHealthSlice: () => initialState
  },
  extraReducers: (builder) => {}
});

export default serverHealthSlice.reducer;
export const { clearServerHealthSlice } = serverHealthSlice.actions;
